import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    ariaLabel: (roleName: string) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Aria label for the role select */
            ariaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (roleName: string) => __intl__.intl().formatMessage({ id: "MemberAccessRoleSelect.ariaLabel?c=1gd3uwu509si5", defaultMessage: "Role to apply to invited members: {roleName}" }, { roleName: roleName }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
